// extracted by mini-css-extract-plugin
export default {"container":"Fallback_container__0+l8e"};